/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetMessagesResponseJson } from './get-messages-response-json';
import { GetMessagesResult } from '../results/get-messages-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { MessageDto } from '../models/message-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
import { orderBy } from 'lodash-es';
//</custom-head>

export class GetMessagesResponse extends ResponseWithErrorGeneric<GetMessagesResponseJson, GetMessagesResult> implements IResponseWithErrorGeneric<GetMessagesResult> {
  public caseId: string = undefined;
  public messages: MessageDto[];

  //<custom-body>
  public messageCollection: MessageDto[] = [];

  constructor(response: HttpResponse<GetMessagesResponse>) {
    super(response, GetMessagesResult.Error);
    if (this.result !== GetMessagesResult.Success) {
      return;
    }

    this.messages = this.body.messages;
    this.messageCollection = this.body.messages ? orderBy(this.body.messages.map(m => new MessageDto(m)), m => m.timestampUtc, 'desc') : [];
  }
  //</custom-body>
}
